import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/pages/home/Home';
import Resume from './components/pages/resume/Resume';
import Recipes from './components/pages/recipes/Recipes';
import Recipe from './components/pages/recipes/Recipe';
import Blog from './components/pages/blog/Blog';
import Contact from './components/pages/contact/Contact';
import Stopwatch from './components/pages/stopwatch/Stopwatch';
import PageNotFound from './components/pages/PageNotFound';
import './App.css';

function App() {

  return (
    <Router>
      <Header />
      <div className='main-content'>
        <Switch>
          <Route exact path='/' component={Home} />
          <Route exact path='/resume/' component={Resume} />
          <Route exact path='/recipes/' component={Recipes} />
          <Route exact path='/blog/' component={Blog} />
          <Route exact path='/contact/' component={Contact} />
          <Route exact path='/stopwatch/' component={Stopwatch} />

          <Route exact path='/recipes/:recipeId/' component={Recipe} />

          <Route component={PageNotFound} />
        </Switch>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
